/**
 * Current clients are on a program. Prospects filled out a form (or were
 * added) but never started. Completed finished a program and are not active.
 * Admins and archived rows are omitted; archive has its own section.
 */
export function clientListGroup(user) {
    if (user.deletedAt || user.role?.name === 'Admin') {
        return null;
    }
    if (user.programType) {
        return 'current';
    }
    if (user.programCompleted) {
        return 'completed';
    }
    return 'prospect';
}
